/* Maison Luxure — animations de la page d'accueil */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function split(el){
    if(el.dataset.mlSplitDone) return; el.dataset.mlSplitDone = 1;
    var i = 0;
    (function walk(node){
      Array.prototype.slice.call(node.childNodes).forEach(function(n){
        if(n.nodeType === 3){
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function(part){
            if(!part) return;
            if(/^\s+$/.test(part)){ frag.appendChild(document.createTextNode(part)); return; }
            var w = document.createElement('span'); w.className = 'w';
            var s = document.createElement('span'); s.textContent = part; s.style.setProperty('--i', i++);
            w.appendChild(s); frag.appendChild(w);
          });
          var prev = n.previousSibling, first = frag.firstChild;
          if(prev && prev.nodeType === 1 && first && first.className === 'w' && /^\S/.test(n.textContent)){
            var nw = document.createElement('span'); nw.className = 'nw';
            node.insertBefore(nw, prev); nw.appendChild(prev); nw.appendChild(first);
          }
          n.parentNode.replaceChild(frag, n);
        } else if(n.nodeType === 1){ walk(n); }
      });
    })(el);
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, {rootMargin:'0px 0px -8% 0px', threshold:.12}) : null;

  var parallax = [];
  function init(root){
    root = root || document;
    root.querySelectorAll('.ml-split').forEach(split);
    root.querySelectorAll('[data-ml-reveal], .ml-split').forEach(function(el){
      if(reduce || !io){ el.classList.add('is-in'); } else { io.observe(el); }
    });
    root.querySelectorAll('[data-ml-parallax]').forEach(function(el){ if(parallax.indexOf(el) < 0) parallax.push(el); });
    root.querySelectorAll('[data-ml-count]').forEach(function(el){
      if(el.dataset.mlCountDone) return; el.dataset.mlCountDone = 1;
      var end = parseInt(el.dataset.mlCount, 10) || 0, suffix = el.dataset.mlSuffix || '';
      if(reduce || !io){ el.textContent = end.toLocaleString('fr-FR') + suffix; return; }
      var o = new IntersectionObserver(function(en){
        if(!en[0].isIntersecting) return; o.disconnect();
        var t0 = performance.now(), dur = 1800;
        (function step(t){
          var p = Math.min(1, (t - t0) / dur), v = Math.round(end * (1 - Math.pow(1 - p, 3)));
          el.textContent = v.toLocaleString('fr-FR') + suffix;
          if(p < 1) requestAnimationFrame(step);
        })(t0);
      }); o.observe(el);
    });
    root.querySelectorAll('[data-ml-tabs]').forEach(function(sec){
      if(sec.dataset.mlBound) return; sec.dataset.mlBound = 1;
      var tabs = sec.querySelectorAll('[data-ml-tab]'), panels = sec.querySelectorAll('.ml-panel');
      tabs.forEach(function(t){ t.addEventListener('click', function(){
        tabs.forEach(function(x){ x.setAttribute('aria-selected', x === t); });
        panels.forEach(function(p, i){ p.hidden = (i !== +t.dataset.mlTab); });
      }); });
      function rail(){ var p = sec.querySelector('.ml-panel:not([hidden]) .ml-rail'); return p; }
      function go(dir){ var r = rail(); if(!r) return; var card = r.querySelector('.ml-pcard'); var step = card ? card.getBoundingClientRect().width + 16 : 300; r.scrollBy({left: dir * step * 2, behavior: reduce ? 'auto' : 'smooth'}); }
      var prev = sec.querySelector('[data-ml-prev]'), next = sec.querySelector('[data-ml-next]');
      if(prev) prev.addEventListener('click', function(){ go(-1); });
      if(next) next.addEventListener('click', function(){ go(1); });
    });
    root.querySelectorAll('[data-ml-seo-toggle]').forEach(function(btn){
      if(btn.dataset.mlBound) return; btn.dataset.mlBound = 1;
      btn.addEventListener('click', function(){
        var s = btn.closest('.ml-seo'); var open = s.classList.toggle('is-open');
        btn.querySelector('span').textContent = open ? btn.dataset.less : btn.dataset.more;
        btn.setAttribute('aria-expanded', open);
      });
    });
  }
  var ticking = false;
  function onScroll(){
    if(ticking || reduce) return; ticking = true;
    requestAnimationFrame(function(){
      var vh = window.innerHeight;
      parallax.forEach(function(el){
        var r = el.parentElement.getBoundingClientRect();
        if(r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * -(parseFloat(el.dataset.mlParallax) || 60)) + 'px,0)';
      });
      ticking = false;
    });
  }
  document.addEventListener('DOMContentLoaded', function(){ init(); onScroll(); });
  window.addEventListener('scroll', onScroll, {passive:true});
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
